<template>
	<el-main class="portal-lmaes">
		<Banner />
		<LmAesIntro />
		<LmAesRag />
		<LmAesFalcon />
		<LmAesActon />
		<LmAesDemoCases />
	</el-main>
</template>

<script>
	import Banner from './LmAesBanner'
  import LmAesIntro from './LmAesIntro'
	import LmAesRag from './LmAesRag'
	import LmAesFalcon from './LmAesFalcon'
	import LmAesActon from './LmAesActon'
	import LmAesDemoCases from './LmAesDemoCases'
	export default {
		name: 'PortalLmAes',
		components: {
			Banner,
			LmAesIntro,
			LmAesRag,
			LmAesFalcon,
			LmAesActon,
			LmAesDemoCases
		},
		data() {
			return {}
		}
	}
</script>

<style>
	.rect-bg {
		position: absolute;
		left: 0;
		float: left;
		width: calc(100vw - 17px);
		min-width: 1200px;
		height: 2549px;
		-webkit-clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		background: rgba(255,255,255,.3);
	}
  .portal-lmaes {
    position: relative; background-color: rgba(234,242,249,.22);
    overflow-y: hidden;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalLmAes.vue